import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartCompare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-compare"} maskId="square-filled-radius-0-stroke-1-IconChartCompare"><path d="M4 20H21V21H3V3H4V20Z" fill="currentColor"/><path d="M8 19H7V11H8V19Z" fill="currentColor"/><path d="M11 19H10V7H11V19Z" fill="currentColor"/><path d="M16 19H15V9H16V19Z" fill="currentColor"/><path d="M19 19H18V5H19V19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChartCompare;
